<template lang="pug">
  DefaultLayout
    BasePopup(v-if="redirectLink" @close="redirectLink = ''")
      div.redirect-popup Чтобы совершить платеж, перейдите на страницу платежной системы
        Btn(:href="redirectLink" target="_blank" @click="redirectLink = ''") Перейти на страницу платежной системы
    CommonSection(v-if="newTariff" :title="`Оплата – тариф ${newTariff.name}`" :back="{ title: 'Назад', name: 'tariffs' }")
      .b-pay-page
        FormBlock(mobile)
          ._title Выберите период оплаты
          .b-pay-periods
            ._item(v-for="(item, i) in payPeriods" :class="{ selected: i === selectedPayPeriodIndex }" @click="selectedPayPeriodIndex = i")
              ._label(v-if="item.discount") {{ item.discount }}
              ._title {{ item.title }}
              ._price
                BaseInput._input(v-if="item.field" v-model="item.field.value" v-bind="item.field" @change="paySumChanged()")
                ._price-full(v-else) {{ item.priceFull }} ₽
                ._price-per-day {{ item.pricePerDay }} ₽/день
        FormBlock(mobile)._sidebar
          ._title Подтверждение заказа
          .b-total
            ._title Тариф
            ._value {{ newTariff.name }}
            ._title Период
            ._value {{ arbitaryPaySum.days || selectedPayPeriod.title }}
            ._title Сумма
            ._value {{ paymentSum }} ₽
            BaseInput._promo(v-model="promoCode.value" v-bind="promoCode")
            ._autopay
              BaseCheckbox(v-model="isAutoPaymentSource" label="Подключить автоплатеж")
              a(v-if="isAutoPaymentSource" href="/autopay-offer" target="_blank") Условия автоматического списания
            ._title.-final Итого
            ._value.-final {{ paymentSum }} ₽
          Btn(lg @click="pay")._btn-pay Оплатить
          ._notify(v-if="newTariff !== actualTariff") После поступления средств на баланс будет активирован выбранный тариф <span>{{newTariff.name}}</span>.

</template>

<script>

import form from '@/utils/form';
import utils from '@/utils/common';
import api from '@/api/payment';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
import BaseInput from '@/components/BaseInput.vue';
import BasePopup from '@/components/BasePopup.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';

export default {
  name: 'PersonalPayPage',
  components: {
    BaseCheckbox,
    BasePopup,
    BaseInput,
    DefaultLayout,
    CommonSection,
    FormBlock,
  },
  data() {
    return {
      isAutoPaymentSource: false,
      redirectLink: '',
      selectedPayPeriodIndex: 0,
      promoCode: form.createFieldObject('text', 'Промокод', ''),
      arbitaryPaySumField: form.createFieldObject('int', 'Сумма', '', { required: 'Укажите сумму', number: 'Укажите число' }),
    };
  },
  created() {
    this.$store.dispatch('tariff/fetchItems');
  },
  computed: {
    selectedPayPeriod() { return this.payPeriods[this.selectedPayPeriodIndex]; },
    arbitaryPaySum() {
      const title = 'Произвольная сумма';
      const selected = this.selectedPayPeriodIndex === this.simplePayPeriods.length;

      const field = this.arbitaryPaySumField;
      let { pricePerDay } = this.tariff;

      const amount = field.value;

      let discount = '';

      if (amount >= pricePerDay * 365 * 0.8) {
        pricePerDay *= 0.8;
        discount = '-20%';
      }

      let days = '';

      if (selected) {
        days = Math.floor(field.value / pricePerDay) ?? 0;
        if (Number.isNaN(days)) days = 0;
        days = utils.pluralWord(days, 'день', 'дня', 'дней');
      }

      return {
        field,
        title,
        days,
        pricePerDay,
        discount,
      };
    },
    tariff() { return this.newTariff ?? this.actualTariff; },
    newTariff() { return this.tariffs.find(t => t.id === +this.$route.params.tariffId) ?? {}; },
    actualTariff() { return this.tariffs.find(t => t.id === this.$store.state.auth.user.tariff.id) ?? {}; },
    tariffs() { return this.$store.getters['tariff/itemsToShow']; },
    paymentSum() { return this.selectedPayPeriod.priceFull || this.selectedPayPeriod.field?.value; },
    usedPromoCodes() { return this.$store.state.auth.user?.customInfo?.usedPromoCodes ?? []; },
    simplePayPeriods() {
      console.log('payPeriods');
      return [365, 180, 90, 30, 7].map(d => {
        const kDiscount = d >= 365 ? 0.8 : 1;

        return {
          pricePerDay: this.tariff.pricePerDay * kDiscount,
          priceFull: this.tariff.pricePerDay * d * kDiscount,
          discount: d >= 365 ? '-20%' : false,
          title: utils.pluralWord(d, 'день', 'дня', 'дней'),
        };
      });
    },
    payPeriods() { return [...this.simplePayPeriods, this.arbitaryPaySum]; },
  },
  methods: {
    paySumChanged() {
      const { field } = this.arbitaryPaySum;
      form.validateField({ field }, 'field');
    },
    pay() {
      const correctPromo = 'om750';
      const promo = this.promoCode.value.toLowerCase();

      if (promo) {
        let err = '';

        if (promo !== correctPromo) {
          err = 'Такого промокода не существует';
        } else if (this.usedPromoCodes.includes(correctPromo)) {
          err = 'Вы уже использовали этот промокод';
        } else if (this.paymentSum < this.newTariff.pricePerDay * 30 * 0.5) {
          err = 'Промокод действителен при оплате от 30 дней';
        }

        if (err) {
          this.promoCode.error = err;
          return;
        }
      }

      const data = {
        amount: Math.ceil(this.paymentSum * 100),
        tariff: this.newTariff['@id'],
        promoCode: this.promoCode.value,
        isAutopaySource: this.isAutoPaymentSource,
      };

      api.create(data, true)
        .then(r => {
          // open(r.redirectUrl, '_blank'); // eslint-disable-line no-restricted-globals
          this.redirectLink = r.redirectUrl;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.redirect-popup {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;
}

.pay-page {
  display: grid;
  grid-template-columns: 1fr 315px;
  gap: 38px;

  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #232226;
    margin-bottom: 25px;
  }

  &__sidebar {
    grid-column: 2;
    grid-row: 1 / 2 span;
    align-self: start;
  }

  &__btn-pay {
    margin-top: 32px;
    width: 100%;
  }

  &__notify {
    margin-top: 24px;
    background: #F5F7F9;
    border: 1px solid #FFB27B;
    border-radius: 8px;
    padding: 10px 15px;
    font-weight: 400;
    font-size: 13px;
    line-height: 19px;
    color: #788CA1;

    span {
      color: #33A1FB;
      font-weight: bold;
    }
  }

  @media (max-width: 1500px) {
    grid-template-columns: 1fr;

    &__sidebar {
      grid-column: 1;
      grid-row: 3;
    }
  }
}

.pay-periods {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;

  &__item {
    background: #F5F7F9;
    border: 1px solid #F5F7F9;
    border-radius: 6px;
    box-sizing: border-box;
    height: 75px;
    padding: 0 17px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    cursor: pointer;
    gap: 10px;

    &.selected {
      background: #EFF7FF;
      border: 1px solid #85C8FF;
    }
  }

  &__title {
    grid-row: 1 / 2 span;
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0.01em;
    color: #788CA1;
  }

  &__price {
    &-full {
      font-weight: 700;
      font-size: 20px;
      line-height: 1;
      text-align: right;
      letter-spacing: 0.01em;
      color: #33A1FB;
    }

    &-per-day {
      margin-top: 5px;
      font-weight: 400;
      font-size: 10px;
      line-height: 13px;
      text-align: right;
      letter-spacing: 0.01em;
      color: #788CA1;
    }
  }

  &__label {
    position: absolute;
    background: #33A1FB;
    border-radius: 10px;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.01em;
    color: #FFFFFF;
    padding: 0 7px;
    top: -10px;
    right: -10px;
    box-sizing: border-box;
  }

  &__input {
    width: 120px;
    height: 24px;

    &::v-deep {
      input {
        width: 120px;
        height: 24px;
        background: #FFFFFF;

        &::placeholder {
          font-weight: 400;
          font-size: 12px;
          line-height: 130%;
          letter-spacing: 0.01em;
          color: #788CA1;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.total {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;

  &__autopay {
    grid-column: 1 / 2 span;
    margin-top: 20px;
    a {
      display: block;
      margin-top: 10px;
      transition: color 0.3s;
      color: #33A1FB;
      font-size: 12px;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }

  &__promo {
    grid-column: 1 / 2 span;
    margin-top: 17px;
  }

  &__title {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #788CA1;

    &--final {
      font-weight: 700;
      font-size: 18px;
      line-height: 23px;
      color: #33A1FB;
      margin-top: 16px;
    }
  }

  &__value {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    text-align: right;
    color: #33A1FB;

    &--final {
      font-weight: 700;
      font-size: 18px;
      line-height: 23px;
      margin-top: 16px;
    }
  }
}
</style>
